import React from 'react';
import ReactDOM from 'react-dom';
import { ampHandlerInit } from '@/utils/apm';
import './assets/styles/index.css';
import '@aurum/icons/style.css';
import App from './pages/App';
import * as serviceWorker from './serviceWorker';

ampHandlerInit();

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
